import {useAuthenticated, useAuthenticationContext} from "../../contexts/authenticationcontext";
import {Section} from "../../components/grouping/Section";
import {Col, Row} from "react-bootstrap";
import {SelectionList} from "../../components/SelectionList";
import {useState} from "react";
import {ArticleOption} from "../../components/admin/ArticleOption";
import {RiArticleFill} from "react-icons/ri";
import {FaFileAlt, FaHandshake} from "react-icons/fa";
import {GrGallery} from "react-icons/gr";
import {BiSolidPhotoAlbum} from "react-icons/bi";
import {VscGraph} from "react-icons/vsc";
import {PiFileHtml} from "react-icons/pi";
import {CgProfile} from "react-icons/cg";
import {MdSupervisorAccount} from "react-icons/md";
import {SiClubhouse} from "react-icons/si";
import {ListItemButton} from "../../components/ListItemButton";
import {FileOption} from "../../components/admin/FileOption";
import {PartnerOption} from "../../components/admin/PartnerOption";
import {GalleryOption} from "../../components/admin/GalleryOption";
import {AlbumOption} from "../../components/admin/AlbumOption";
import {ResultsOption} from "../../components/admin/ResultsOption";
import {HtmlFragOption} from "../../components/admin/HtmlFragOption";
import {MemberOption} from "../../components/admin/MemberOption";
import {ClubOption} from "../../components/admin/ClubOption";
import {RiPagesLine} from "react-icons/ri";
import {PageConfigOption} from "../../components/admin/PageConfigOption";
import {AccountsOption} from "../../components/admin/AccountsOption";
import {FaBookmark} from "react-icons/fa";
import {MagazineOption} from "../../components/admin/MagazineOption";
import PropTypes from "prop-types";
import {FaMapMarked} from "react-icons/fa";
import {SectorOption} from "../../components/admin/SectorOption";

import {FaWpforms} from "react-icons/fa6";
import {FormslOption} from "../../components/admin/FormslOption";

export function AdminDashboardPage() {
    const {memberNumber} = useAuthenticationContext();

    const {sectorControl, role} = useAuthenticated();
    const [selectedOption, setSelectedOption] = useState(sectorControl === 'ALL' ? <ArticleOption title={"Artikels"}/> :
        <MemberOption title={"Leden beheer"}/>);


    return <div>
        {role === 'ROLE_ADMIN' ?
            <Section>


                <Col xs={12} md={2} className={"p-2"}>

                    <LeftAdminMenu memberNumber={memberNumber}
                                   onClick={setSelectedOption}/>

                </Col>

                <Col xs={12} md={10} className={"p-2"}>
                    <RightMenuView>
                        {selectedOption}
                    </RightMenuView>
                </Col>
            </Section>
            :
            ""
        }
    </div>
}

function LeftAdminMenu(props) {
    const {onClick, memberNumber} = props;
    return <div>
        <SelectionList>
            <DashboardOptionListItems memberNumber={memberNumber}
                                      onClick={onClick}/>
        </SelectionList>
    </div>
}

function RightMenuView(props) {
    const {children} = props;
    return <div className={"p-2 border border-black rounded-2"}>
        {children}
    </div>
}

function DashboardOptionListItems(props) {
    const {onClick, memberNumber} = props;

    const {sectorControl} = useAuthenticated();
    return <Row className={"g-0 border border-black rounded-2"}>

        {sectorControl === 'ALL' ?
            <SectorControllAllDocuments memberNumber={memberNumber} onClick={onClick}/> : ""}
        <ListItem title={"Leden"} icon={<CgProfile/>} className={"border-bottom rounded-0"}
                  onClick={() => onClick(<MemberOption title={"Leden beheer"}/>)}/>
        {sectorControl === "ALL" ?
            <SectorControllAllLists memberNumber={memberNumber} onClick={onClick}/> : ""}
        <ListItem title={"Clubs"} icon={<SiClubhouse/>}
                  onClick={() => onClick(<ClubOption title={"Clubs beheer"}/>)}/>
        <ListItem title={"Sector"} icon={<FaMapMarked/>}
                  onClick={() => onClick(<SectorOption title={"Sector beheer"}/>)}/>
    </Row>
}

function SectorControllAllDocuments(props) {
    const {memberNumber, onClick} = props;
    return <>
        <ListItem title={"Artikels"} className={"border-bottom rounded-0"}
                  onClick={() => onClick(<ArticleOption title={"Artikels"}/>)}
                  icon={<RiArticleFill/>}/>
        <ListItem title={'Formulieren'} className={'border-bottom rounded-0'}
                  icon={<FaWpforms/>} onClick={() => onClick(<FormslOption title={'Formulieren'}/>)}/>
        <ListItem title={"Bestanden"} className={"border-bottom rounded-0"}
                  onClick={() => onClick(<FileOption
                      title={"Bestanden vervangen"}/>)}
                  icon={<FaFileAlt/>}/>
        <ListItem title={"Partners"} icon={<FaHandshake/>} className={"border-bottom rounded-0"}
                  onClick={() => onClick(<PartnerOption title={"Partner beheer"}/>)}/>
        <ListItem title={"Gallerijen"} icon={<GrGallery/>} className={"border-bottom rounded-0"}
                  onClick={() => onClick(<GalleryOption title={"Gallerij beheer"}/>)}/>
        <ListItem title={"Albums"} icon={<BiSolidPhotoAlbum/>} className={"border-bottom rounded-0"}
                  onClick={() => onClick(<AlbumOption title={"Album beheer"}/>)}/>
        <ListItem title={"Resultaten"} icon={<VscGraph/>} className={"border-bottom rounded-0"}
                  onClick={() => onClick(<ResultsOption title={"Resultaten"}/>)}/>
        <ListItem title={"Tijdschrift"} icon={<FaBookmark/>} className={"border-bottom rounded-0"}
                  onClick={() => onClick(<MagazineOption title={"Tijdschrift beheer"}/>)}/>
        {memberNumber ? memberNumber === "90000" ?
            <ListItem title={"Pagina's"} icon={<RiPagesLine/>} className={"border-bottom rounded-0"}
                      onClick={() => onClick(<PageConfigOption title={"Pagina's"}/>)}/> : "" : ""}
        <ListItem title={"Html frag"} icon={<PiFileHtml/>} className={"border-bottom rounded-0"}
                  onClick={() => onClick(<HtmlFragOption title={"Html fragment"}/>)}/>
    </>
}

function SectorControllAllLists(props) {
    const {onClick} = props;
    return <>
        <ListItem title={"Accounts"} icon={<MdSupervisorAccount/>} className={"border-bottom rounded-0"}
                  onClick={() => onClick(<AccountsOption title={"Account beheer"}/>)}/>
    </>
}


function ListItem(props) {
    const {title, icon, onClick, className} = props;
    return <ListItemButton className={className} onClick={onClick}>
        <Col className={"text-start"}>
            {title}
        </Col>
        <Col xs={"auto"} className={"text-end"}>
            {icon}
        </Col>
    </ListItemButton>
}

ListItem.propTypes = {
    title: PropTypes.string,
    icon: PropTypes.any,
    iconClass: PropTypes.string,
    className: PropTypes.string
};